import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { onboardingGuard } from './core/guards/onboarding.guard';
import { authRoutes } from './features/auth/auth.routes';
import { portalRoutes } from './features/portal/portal.routes';

export const routes: Routes = [
  {
    path: 'app',
    canActivate: [authGuard],
    canActivateChild: [onboardingGuard],
    children: portalRoutes
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/onboarding/onboarding-page.component').then(m => m.OnboardingPageComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'privacidad',
    loadComponent: () =>
      import('./features/legal/politica-privacidad.component').then(m => m.PoliticaPrivacidadComponent)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app'
  },
  {
    path: '**',
    redirectTo: 'app'
  }
];
